"use client";

import React, { useCallback } from "react";
import IconCar from "@lmn/lastminute-react-icons/icons-converted/lastminute-icons-solid/IconCar.js";
import { Checkbox } from "@lmn/design-system";
import { Container } from "@/components/UI/FilterContainer/FilterContainer.styles";
import styled from "styled-components";
import { useFilterState } from "@/lib/Providers/FilterStateProvider/FilterStateProvider";
import { useReactiveSearchParams } from "@/lib/Hooks/useReactiveSearchParams";

const CheckboxWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
`;

const ClickOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  z-index: 0;
`;

interface RentalCarFilterProps {
  delayedUpdate?: boolean;
}

const RentalCarFilter: React.FC<RentalCarFilterProps> = ({
  delayedUpdate = false,
}) => {
  const searchParams = useReactiveSearchParams();
  const { tempFilters, updateFilter, updateTempFilter } = useFilterState();

  // Derive state directly from URL/tempFilters - no local state needed
  const isRentalCar = delayedUpdate
    ? tempFilters.get("rentalCar") === "1"
    : searchParams.get("rentalCar") === "1";

  const handleRentalCarChange = useCallback(() => {
    const newValue = !isRentalCar;
    if (delayedUpdate) {
      updateTempFilter("rentalCar", newValue ? "1" : null);
    } else {
      updateFilter("rentalCar", newValue ? "1" : null);
    }
  }, [isRentalCar, updateFilter, updateTempFilter, delayedUpdate]);

  return (
    <Container>
      <CheckboxWrapper>
        {delayedUpdate && <ClickOverlay onClick={handleRentalCarChange} />}
        <IconCar size={24} />
        <Checkbox
          checkbox={{
            id: "rentalCar",
            label: "Mietwagen (ab Hotel)",
          }}
          isChecked={isRentalCar}
          onChange={delayedUpdate ? () => { } : handleRentalCarChange}
        />
      </CheckboxWrapper>
    </Container>
  );
};

export default RentalCarFilter;
